import { z } from "zod";

export const totp2FASchema = z.object({
  hash: z.string(),
  code: z.string({
    required_error: "You need to enter a code.",
  }),
});

export type Totp2FAFormData = z.infer<typeof totp2FASchema>;
